import "./../scss/app.scss";
import Swiper from "swiper/bundle";
import * as Popper from "@popperjs/core";
import * as bootstrap from "bootstrap";
import AjaxLoadMore_module from "./ajaxLoadMore";
import "./textGradientScroll";

window.AjaxLoadMore = AjaxLoadMore_module;
window.Swiper = Swiper;
window.Popper = Popper;
window.bootstrap = bootstrap;

(function ($) {
  "use strict";

  // Function to animate navigation holder on slide change
  // This is used in the home main slider template part
  window.animateNavigationHolder = function (isTransitioning) {
    const navigationHolder = document.querySelector(
      ".swiper-navigation-holder",
    );
    const navigationContainer = document.querySelector(
      ".swiper-navigation-container",
    );

    if (navigationHolder && navigationContainer) {
      if (isTransitioning) {
        // Remove no-transition class and add slide-changing class
        navigationContainer.classList.remove("no-transition");
        navigationHolder.classList.add("slide-changing");
      } else {
        // Add no-transition class, remove slide-changing, force reflow, then remove no-transition
        navigationContainer.classList.add("no-transition");
        navigationHolder.classList.remove("slide-changing");
        // Force a reflow to ensure the reset is applied immediately
        navigationHolder.offsetHeight;
        setTimeout(() => {
          navigationContainer.classList.remove("no-transition");
        }, 10);
      }
    }
  };

  // Function to update progress indicator (handles multiple instances)
  window.updateProgressIndicator = function (swiperInstance) {
    // Safety check to ensure swiper instance is valid
    if (!swiperInstance || !swiperInstance.slides) {
      return;
    }

    const currentSlide = swiperInstance.activeIndex + 1;
    const totalSlides = swiperInstance.slides.length;
    const progressPercentage = (currentSlide / totalSlides) * 100;

    // Update all instances of current slide number
    const currentElements = document.querySelectorAll(".progress-current");
    if (currentElements.length > 0) {
      currentElements.forEach((element) => {
        element.textContent = currentSlide.toString().padStart(2, "0");
      });
    }

    // Update all instances of total slides number
    const totalElements = document.querySelectorAll(".progress-total");
    if (totalElements.length > 0) {
      totalElements.forEach((element) => {
        element.textContent = totalSlides.toString().padStart(2, "0");
      });
    }

    // Update all instances of progress bar width
    const progressFills = document.querySelectorAll(".progress-fill");
    if (progressFills.length > 0) {
      progressFills.forEach((fill) => {
        fill.style.width = progressPercentage + "%";
      });
    }
  };

  // Make these functions available globally for inline scripts
  window.animateNavigationHolder = animateNavigationHolder;
  window.updateProgressIndicator = updateProgressIndicator;

  $(function () {
    // ==========================================
    // Swiper Initialization - Responsive
    // ==========================================

    // Modular builder swiper is now handled in Vue component

    let swiperMapItems = null;
    function initMapItemsSwiper() {
      const swiperElement = document.querySelector(".locations-swiper");
      if (!swiperElement) return;

      // Check if we're on mobile r it has class needs-swiper
      if (
        window.innerWidth < 768 ||
        swiperElement.classList.contains("needs-swiper")
      ) {
        // Initialize swiper if not already initialized
        if (!swiperMapItems) {
          swiperMapItems = new Swiper(".locations-swiper", {
            slidesPerView: 1.3,
            // Responsive breakpoints
            breakpoints: {
              768: {
                slidesPerView: 3.5,
              },
            },
          });
        }
      } else {
        // Destroy swiper on desktop if it exists
        if (swiperMapItems) {
          swiperMapItems.destroy(true, true);
          swiperMapItems = null;
        }
      }
    }

    let swiperGallery = null;
    function initGallerySwiper() {
      const swiperElement = document.querySelector(
        "#gallery-categories-swiper",
      );
      if (!swiperElement) return;
      // Check if we're on mobile
      if (window.innerWidth < 768) {
        // Initialize swiper if not already initialized
        if (!swiperGallery) {
          swiperGallery = new Swiper("#gallery-categories-swiper", {
            slidesPerView: "auto",
          });
        }
      } else {
        // Destroy swiper on desktop if it exists
        if (swiperGallery) {
          swiperGallery.destroy(true, true);
          swiperGallery = null;
        }
      }
    }

    let swiperCertifications = null;
    function initCertificationsSwiper() {
      const swiperElement = document.querySelector(".swiper-certifications");
      if (!swiperElement) return;

      // Check if we're on mobile r it has class needs-swiper
      if (
        window.innerWidth < 768 ||
        swiperElement.classList.contains("needs-swiper")
      ) {
        // Initialize swiper if not already initialized
        if (!swiperCertifications) {
          swiperCertifications = new Swiper(".swiper-certifications", {
            slidesPerView: 1.3,
            // Responsive breakpoints
            breakpoints: {
              768: {
                slidesPerView: 3.5,
              },
            },
          });
        }
      } else {
        // Destroy swiper on desktop if it exists
        if (swiperCertifications) {
          swiperCertifications.destroy(true, true);
          swiperCertifications = null;
        }
      }
    }

    // Initialize on page load
    initCertificationsSwiper();
    initMapItemsSwiper();
    initGallerySwiper();
    // Handle window resize
    $(window).on("resize", function () {
      initCertificationsSwiper();
      initMapItemsSwiper();
      initGallerySwiper();
    });

    //PopUp Windows
    function popupWindow(url, title, w, h) {
      var win = window.parent;
      var y = win.top.outerHeight / 2 + win.top.screenY - h / 2;
      var x = win.top.outerWidth / 2 + win.top.screenX - w / 2;
      return win.open(
        url,
        title,
        "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
          w +
          ", height=" +
          h +
          ", top=" +
          y +
          ", left=" +
          x,
      );
    }

    $(".popupWindow").on("click", function (event) {
      var url = $(this).attr("href");
      popupWindow(url, "Share", 600, 600);

      event.preventDefault();
      return false;
    });

    // ==========================================
    // Submenu Functionality
    // ==========================================

    // Submenu hover and click functionality
    const $navItemsWithDropdown = $(".nav-menu-item--has-dropdown");
    const $submenus = $(".submenu");
    let hoverTimeout;

    // Show submenu function
    function showSubmenu($menuItem) {
      const menuId = $menuItem.data("submenu");
      const $submenu = $menuItem.find(".submenu");
      const $dropdownIcon = $menuItem.find(".nav-menu-item__dropdown-icon");
      const $menuLink = $menuItem.find(".nav-menu-item__link");

      if ($submenu.length) {
        // Hide all other submenus first
        hideAllSubmenus();

        // Show the current submenu and add active states
        $submenu.addClass("is-active");
        $menuItem.addClass("is-open nav-menu-item--active");
        $menuLink.addClass("nav-menu-item__link--active");
        $dropdownIcon.addClass("nav-menu-item__dropdown-icon--rotated");

        // Update row data attributes for responsive behavior
        updateSubmenuRowData($submenu);
      }
    }

    // Hide submenu function
    function hideSubmenu($menuItem) {
      const $submenu = $menuItem.find(".submenu");
      const $dropdownIcon = $menuItem.find(".nav-menu-item__dropdown-icon");
      const $menuLink = $menuItem.find(".nav-menu-item__link");

      if ($submenu.length) {
        $submenu.removeClass("is-active");
        $menuItem.removeClass("is-open nav-menu-item--active");
        $menuLink.removeClass("nav-menu-item__link--active");
        $dropdownIcon.removeClass("nav-menu-item__dropdown-icon--rotated");
      }
    }

    // Hide all submenus
    function hideAllSubmenus() {
      $submenus.removeClass("is-active");
      $navItemsWithDropdown.removeClass("is-open nav-menu-item--active");
      $(".nav-menu-item__link").removeClass("nav-menu-item__link--active");
      $(".nav-menu-item__dropdown-icon").removeClass(
        "nav-menu-item__dropdown-icon--rotated",
      );
    }

    // Update submenu row data attributes for proper responsive behavior
    function updateSubmenuRowData($submenu) {
      const $rows = $submenu.find(".submenu__row");

      $rows.each(function () {
        const $row = $(this);
        const itemCount = $row.find(".submenu__item").length;
        $row.attr("data-items", itemCount);
      });
    }

    // Click events for all screen sizes (no hover)
    $navItemsWithDropdown.on("click", function (e) {
      // Don't prevent default if clicking on a link within the submenu
      if ($(e.target).closest(".submenu__learn-more-link, .submenu a").length) {
        return; // Allow the link to work normally
      }

      e.preventDefault();

      const $this = $(this);
      const isOpen = $this.hasClass("is-open");

      if (isOpen) {
        hideSubmenu($this);
      } else {
        showSubmenu($this);
      }
    });

    // Close submenus when clicking outside
    $(document).on("click", function (e) {
      // Don't close submenus if clicking on submenu links
      if ($(e.target).closest(".submenu__learn-more-link, .submenu a").length) {
        return; // Allow the link to work normally
      }

      if (
        !$(e.target).closest(".nav-menu-item--has-dropdown, .submenu").length
      ) {
        hideAllSubmenus();
      }
    });

    // Handle window resize
    $(window).on("resize", function () {
      // Update submenu row data on resize
      $submenus.each(function () {
        updateSubmenuRowData($(this));
      });

      // Close all submenus on resize to prevent layout issues
      hideAllSubmenus();
    });

    // Accessibility: Keyboard navigation
    $navItemsWithDropdown.on("keydown", function (e) {
      const $this = $(this);

      switch (e.keyCode) {
        case 13: // Enter
        case 32: // Space
          e.preventDefault();
          const isOpen = $this.hasClass("is-open");

          if (isOpen) {
            hideSubmenu($this);
          } else {
            showSubmenu($this);
          }
          break;

        case 27: // Escape
          hideSubmenu($this);
          break;
      }
    });

    // Initialize submenu row data attributes on page load
    $submenus.each(function () {
      updateSubmenuRowData($(this));
    });

    // Ensure submenu links are clickable
    $(document).on(
      "click",
      ".submenu__learn-more-link, .submenu a",
      function (e) {
        // Allow the link to work normally
        e.stopPropagation();
      },
    );

    // ==========================================
    // Mobile Menu Functionality
    // ==========================================

    const $mobileHamburger = $(".mobile-hamburger-menu");
    const $mobileNavMenu = $(".mobile-navigation-menu");
    const $mobileNavItemsWithDropdown = $(".mobile-nav-item--has-dropdown");
    const $mobileSubmenuPopups = $(".mobile-submenu-popup");

    // Toggle mobile menu
    $mobileHamburger.on("click", function (e) {
      e.preventDefault();

      const isOpen = $mobileNavMenu.hasClass("is-open");

      if (isOpen) {
        $mobileNavMenu.removeClass("is-open");
        // Close all mobile submenu popups when closing main menu
        hideAllMobileSubmenuPopups();
        $(".mobile-nav-item__dropdown-icon").removeClass(
          "mobile-nav-item__dropdown-icon--rotated",
        );
        // Re-enable body scroll
        $("body").removeClass("mobile-menu-open");
      } else {
        $mobileNavMenu.addClass("is-open");
        // Prevent body scroll when mobile menu is open
        $("body").addClass("mobile-menu-open");
      }
    });

    // Close mobile menu with close button
    $(".mobile-menu-close").on("click", function (e) {
      e.preventDefault();
      $mobileNavMenu.removeClass("is-open");
      hideAllMobileSubmenuPopups();
      $(".mobile-nav-item__dropdown-icon").removeClass(
        "mobile-nav-item__dropdown-icon--rotated",
      );
      // Re-enable body scroll
      $("body").removeClass("mobile-menu-open");
    });

    // Mobile submenu popup functionality - entire item is clickable
    $mobileNavItemsWithDropdown.on("click", function (e) {
      // Don't prevent default if clicking on a link within the mobile submenu
      if (
        $(e.target).closest(
          ".mobile-submenu-popup__item-link, .mobile-submenu-popup a",
        ).length
      ) {
        return; // Allow the link to work normally
      }

      e.preventDefault();
      e.stopPropagation();

      const $this = $(this);
      const submenuId = $this.data("submenu");
      const popupId = submenuId.replace("-mobile", "") + "-popup";
      const $popup = $("#" + popupId);

      if ($popup.length) {
        // Show mobile submenu popup
        showMobileSubmenuPopup($popup);
      }
    });

    // Show mobile submenu popup
    function showMobileSubmenuPopup($popup) {
      // Close main mobile menu first
      $mobileNavMenu.removeClass("is-open");

      // Show popup with animation
      $popup.addClass("is-active");
      $("body").addClass("mobile-submenu-popup-open");
    }

    // Hide mobile submenu popup
    function hideMobileSubmenuPopup($popup) {
      $popup.removeClass("is-active");
      $("body").removeClass("mobile-submenu-popup-open");

      // Show main mobile menu again
      setTimeout(() => {
        $mobileNavMenu.addClass("is-open");
        $("body").addClass("mobile-menu-open");
      }, 100);
    }

    // Hide all mobile submenu popups
    function hideAllMobileSubmenuPopups() {
      $mobileSubmenuPopups.removeClass("is-active");
      $("body").removeClass("mobile-submenu-popup-open");
    }

    // Mobile submenu popup back button
    $(document).on("click", ".mobile-submenu-popup__back", function (e) {
      e.preventDefault();
      const $popup = $(this).closest(".mobile-submenu-popup");
      hideMobileSubmenuPopup($popup);
    });

    // Close mobile submenu popup when clicking outside content area
    $mobileSubmenuPopups.on("click", function (e) {
      if ($(e.target).hasClass("mobile-submenu-popup")) {
        const $popup = $(this);
        hideMobileSubmenuPopup($popup);
      }
    });

    // Close mobile menu when clicking outside
    $(document).on("click", function (e) {
      if (
        !$(e.target).closest(
          ".mobile-navigation-menu, .mobile-hamburger-menu, .mobile-submenu-popup",
        ).length
      ) {
        $mobileNavMenu.removeClass("is-open");
        hideAllMobileSubmenuPopups();
        $(".mobile-nav-item__dropdown-icon").removeClass(
          "mobile-nav-item__dropdown-icon--rotated",
        );
        // Re-enable body scroll
        $("body").removeClass("mobile-menu-open");
      }
    });

    // Close mobile menu on window resize (when switching to desktop)
    $(window).on("resize", function () {
      if ($(window).width() >= 1200) {
        $mobileNavMenu.removeClass("is-open");
        hideAllMobileSubmenuPopups();
        $(".mobile-nav-item__dropdown-icon").removeClass(
          "mobile-nav-item__dropdown-icon--rotated",
        );
        // Re-enable body scroll
        $("body").removeClass("mobile-menu-open");
      }
    });

    // Ensure mobile submenu links are clickable
    $(document).on(
      "click",
      ".mobile-submenu-popup__item-link, .mobile-submenu-popup a",
      function (e) {
        // Allow the link to work normally
        e.stopPropagation();
      },
    );

    // ==========================================
    // Posts Gallery Load More Functionality
    // ==========================================

    const $loadMoreBtn = $("#load-more-btn");
    const $postsGalleryItems = $(".posts-gallery-items");

    if ($loadMoreBtn.length && $postsGalleryItems.length) {
      let currentPage = 1;
      let isLoading = false;

      // Get AJAX URL from data attribute
      const ajaxUrl = $postsGalleryItems
        .closest(".posts-gallery-section")
        .data("ajax-url");

      // Get current page parameters from URL
      const urlParams = new URLSearchParams(window.location.search);
      const selectedCategory =
        urlParams.get("term-category") ||
        urlParams.get("term-post_tag") ||
        "all";

      // Get section parameters from data attributes or defaults
      const sectionData = $postsGalleryItems
        .closest(".posts-gallery-section")
        .data();
      const postType = sectionData.postType || "post";
      const taxonomyType = sectionData.taxonomyType || "category";
      const showDate = sectionData.showDate || false;
      const showTaxonomy = sectionData.showTaxonomy || false;

      $loadMoreBtn.on("click", function (e) {
        e.preventDefault();

        if (isLoading) return;

        isLoading = true;
        currentPage++;

        // Update button text to show loading state
        const originalText = $loadMoreBtn.text();
        $loadMoreBtn.text("Loading...").prop("disabled", true);

        // Prepare AJAX request
        const params = {
          action: "load_more_posts_gallery",
          current_page: currentPage,
          post_type: postType,
          taxonomy_type: taxonomyType,
          show_date: showDate,
          show_taxonomy: showTaxonomy,
          selected_category: selectedCategory,
        };

        // Make AJAX request
        $.ajax({
          url: ajaxUrl,
          type: "POST",
          data: params,
          success: function (response) {
            if (response.success) {
              // Append new content to the gallery
              $postsGalleryItems.append(response.data.html);

              // Check if there are more posts available
              if (!response.data.has_more_posts) {
                // No more posts available
                $loadMoreBtn.text("No More Posts").prop("disabled", true);

                // Hide the button after a short delay
                setTimeout(function () {
                  $loadMoreBtn.closest(".load-more-holder").fadeOut();
                }, 2000);
              } else {
                // Re-enable button for more posts
                $loadMoreBtn.text(originalText).prop("disabled", false);
              }
            } else {
              // Error occurred
              $loadMoreBtn.text("Error Loading Posts").prop("disabled", false);
              currentPage--; // Reset page count on error
            }
          },
          error: function () {
            // Handle error
            $loadMoreBtn.text("Error Loading Posts").prop("disabled", false);
            currentPage--; // Reset page count on error
          },
          complete: function () {
            isLoading = false;
          },
        });
      });
    }

    // ==========================================
    // Sticky Header Functionality
    // ==========================================

    const header_scroll_trigger = "fixed"; // 'fixed' or 'dynamic'
    const $headerNavbar = $(".header-navbar");
    let lastScrollTop = 0;
    let lastStateChange = 0;
    const debounceDelay = 150; // Prevent rapid state changes within 150ms

    const checkScrollState = () => {
      const scrollTop = $(this).scrollTop();

      if ($headerNavbar.length) {
        const hasFixed = $headerNavbar.hasClass("fixed");
        const hasSlim = $headerNavbar.hasClass("slim");
        const now = Date.now();

        // Store original state if not already stored
        if (!$headerNavbar.data("originally-fixed") && hasFixed) {
          $headerNavbar.data("originally-fixed", true);
        }

        const wasOriginallyFixed = $headerNavbar.data("originally-fixed");

        if (header_scroll_trigger === "fixed") {
          // Fixed mode: Change state based on absolute scroll position with hysteresis to prevent glitching
          // Use different thresholds for up vs down to create a buffer zone
          if (scrollTop > 220 && !hasSlim) {
            // Change to slim state when scrolling past 220px
            if (hasFixed || wasOriginallyFixed) {
              // Fixed header: calculate height, switch classes, adjust margin
              const headerHeight = $headerNavbar.outerHeight();
              $headerNavbar.addClass("slim").removeClass("fixed");
              const slimHeight = $headerNavbar.outerHeight();
              $("body").css("margin-top", "-" + slimHeight + "px");
            } else {
              // Non-fixed header: just add slim class
              $headerNavbar.addClass("slim");
            }
          } else if (scrollTop <= 180 && hasSlim) {
            // Revert to original state when scrolling back to 180px or less
            if (wasOriginallyFixed) {
              // Originally fixed header: remove body margin and switch back to fixed
              $("body").css("margin-top", "");
              $headerNavbar.removeClass("slim").addClass("fixed");
            } else {
              // Non-fixed header: just remove slim class
              $headerNavbar.removeClass("slim");
            }
          }
        } else {
          // Dynamic mode: Original behavior based on scroll direction
          const scrollDifference = scrollTop - lastScrollTop;

          // Check if enough time has passed since last state change (debouncing)
          const canChangeState = now - lastStateChange > debounceDelay;

          // Auto-revert when near top of page
          if (scrollTop <= 20 && hasSlim) {
            if (wasOriginallyFixed) {
              // Originally fixed header: remove body margin and switch back to fixed
              $("body").css("margin-top", "");
              $headerNavbar.removeClass("slim").addClass("fixed");
            } else {
              // Non-fixed header: just remove slim class (no margin to remove)
              $headerNavbar.removeClass("slim");
            }
            lastStateChange = now;
          }
          // Add slim class when scrolling down (with debouncing to prevent glitching)
          else if (
            canChangeState &&
            (hasFixed || wasOriginallyFixed
              ? scrollDifference > 5
              : scrollDifference > 8) &&
            scrollTop > 30 &&
            !hasSlim
          ) {
            if (hasFixed || wasOriginallyFixed) {
              // Fixed header: calculate height, switch classes, adjust margin
              const headerHeight = $headerNavbar.outerHeight();
              $headerNavbar.addClass("slim").removeClass("fixed");
              const slimHeight = $headerNavbar.outerHeight();
              $("body").css("margin-top", "-" + slimHeight + "px");
            } else {
              // Non-fixed header: just add slim class (no margin compensation to avoid glitching)
              $headerNavbar.addClass("slim");
            }
            lastStateChange = now;
          }
          // Remove slim class when scrolling up significantly (with debouncing)
          else if (
            canChangeState &&
            (wasOriginallyFixed
              ? scrollDifference < -20
              : scrollDifference < -15) &&
            hasSlim
          ) {
            if (wasOriginallyFixed) {
              // Originally fixed header: remove margin and switch back to fixed
              $("body").css("margin-top", "");
              $headerNavbar.removeClass("slim").addClass("fixed");
            } else {
              // Non-fixed header: just remove slim class (no margin to remove)
              $headerNavbar.removeClass("slim");
            }
            lastStateChange = now;
          }
        }
      }

      lastScrollTop = scrollTop;
    };

    checkScrollState();

    $(window).on("scroll", function () {
      checkScrollState();
    });
  });
})(jQuery);
